import { InstructorService } from '../services/instructor.service';

export class Instructor {
  public ultimoExamen: any = null;
  public graduacion: any = null;
  public email: string = '';

  constructor(
    public id: number,
    public nombre: string,
    public apellido: string,
    public nroLibreta: number | null,
    public activo: boolean = true,
    public isEditMode: boolean = false,
    public disableValidation: boolean = false
  ) {
    if (!disableValidation && (!nombre || !apellido)) {
      throw new Error('nombre and apellido are required fields');
    }
  }

  static fromRows(rows: any[]): Instructor[] {
    return rows.map(row => Instructor.fromApiData(row));
  }

  static fromRawData(data: any): Instructor {
    return Instructor.fromApiData(data);
  }

  static fromApiData(data: any): Instructor {
    return new Instructor(
      data.id,
      data.nombre || '',
      data.apellido || '',
      data.nroLibreta !== undefined && data.nroLibreta !== null ? data.nroLibreta : null,
      data.activo !== undefined ? data.activo : true
    );
  }

  fill(newFields: Partial<Instructor>): void {
    for (let field in newFields) {
      if (this.hasOwnProperty(field) && newFields.hasOwnProperty(field)) {
        const key = field as keyof Instructor;
        if (this[key] !== undefined) {
          (this[key] as any) = newFields[key]!;
        }
      }
    }
  }

  get nombreApellido(): string {
    return `${this.nombre} ${this.apellido}`;
  }

  get nombreCompleto(): string {
    return this.nombreApellido;
  }

  fetchUltimoExamen(instructorService: InstructorService): void {
    if (this.nroLibreta !== null && this.nroLibreta !== 0) {
      instructorService.getUltimoExamen(this.nroLibreta).subscribe(
        (examen) => {
          this.ultimoExamen = examen;
        },
        (err) => {
          console.error('Error fetching último examen:', err);
        }
      );
    }
  }

  fetchGraduacion(instructorService: InstructorService): void {
    if (this.nroLibreta !== null && this.nroLibreta !== 0) {
      instructorService.getGraduacion(this.nroLibreta).subscribe(
        (graduacion) => {
          this.graduacion = graduacion;
        },
        (err) => {
          console.error('Error fetching graduación actual:', err);
        }
      );
    }
  }

  fetchEmail(instructorService: InstructorService): void {
    if (this.nroLibreta !== null && this.nroLibreta !== 0) {
      instructorService.getEmail(this.nroLibreta).subscribe(
        (email) => {
          this.email = email.email;
        },
        (err) => {
          console.error('Error fetching email:', err);
        }
      );
    }
  }
}